import React,{lazy} from "react";
import Login from "../modules/authentication/Login";
import Logout from "../modules/super-admin/container/Logout/Logout";
import NotFound from "../pages/NotFound";
import PrivateRoutes from "../routes/PrivateRoutes";
import LayoutWrapper from "../HoC/LayoutWrapper";
// const Profile = lazy(() => import("../modules/super-admin/Profile/"));
// const ProfileUpdate = lazy(() => import("../modules/super-admin/Profile/ManageProfile"));
const Setpassword = lazy(() => import("../modules/super-admin/container/ResetPassword/SetPassword"));
const Forgot = lazy(() => import("../modules/super-admin/container/ForgotPassword/ForgotPassword"));

// Master Layout

const CommonRouter = [
  {
    path: "/",
    element: <Login />,
  },
  {
    path: "/forgot-password",
    element: <Forgot />,
  },
  {
    path: "/reset-password/:token",
    element: <Setpassword />,
  },
  {
    path: "/logout",
    element: <Logout/>,
  },
  {
    path: "*",
    element: <NotFound /> 
  },
  // {
  //   element: <PrivateRoutes />,
  //   children: [{
  //     path: "profile",
  //     element: <LayoutWrapper childComponent={<Profile />} />,
  //   },
  //   {
  //     path: "profile/edit",
  //     element: <LayoutWrapper childComponent={<ProfileUpdate />} />,
  //   },
  // ],
  // }
];

export default CommonRouter;